<template>
  <div class="SMS">
    <div class="sent">
      {{ message.createdAt | dateformat("lll") }}
      <span> (sent) </span>
      <!-- <span> ({{ message.status }}) </span> -->
    </div>
    <div
      class="sender"
      :key="from.id"
      v-for="from of message.fromList">
      {{ from.firstName }} {{ from.lastName }}
    </div>
    <div class="body">
      <span>SMS: </span>
      {{ message.msg }}
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data: function() {
    return {
    }
  },

  props: {
     message: {
      type: Object,
      required: true,
    },
 },

  mounted() {},

  methods: {},

  computed: {},

  filters: {
    dateformat: (value, format) => {
      return moment(value).format(format);
    },
  },
}
</script>

<style lang="scss" scoped>
.SMS {
  background-color: var(--pale-grey-three);

  .sender {
    color: var(--blue-purple);
    font-weight: bold;
    padding-bottom: 1em;
  }

}
</style>

